import { render } from "./FlowResourceCard.vue?vue&type=template&id=147ed60a&scoped=true"
import script from "./FlowResourceCard.vue?vue&type=script&lang=js"
export * from "./FlowResourceCard.vue?vue&type=script&lang=js"

import "./FlowResourceCard.vue?vue&type=style&index=0&id=147ed60a&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-147ed60a"]])

export default __exports__